import { useMemo, useState } from "react";
import { categories, comics } from "@/mocks/comics";
import ComicCard from "./ComicCard";

export default function CategorySection() {
  const [active, setActive] = useState<string>("全部");

  const filtered = useMemo(() => {
    if (active === "全部") return comics;
    return comics.filter((c) => c.category === active);
  }, [active]);

  return (
    <section id="category" className="relative w-full bg-background-50 py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-10">
          <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-bold mb-1">
            <i className="ri-grid-fill" aria-hidden="true"></i>
            六大分类
          </span>
          <h2 className="font-heading text-foreground-950 text-2xl md:text-4xl">分类浏览</h2>
          <p className="text-foreground-600 text-sm mt-2 max-w-xl mx-auto">
            沙雕、无厘头、神转折、脑洞……总有一款戳中你的笑点，点分类快速找到你爱的口味。
          </p>
        </div>

        {/* Category cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-8">
          {categories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => setActive(cat.name)}
              className={`flex items-center gap-3 p-3.5 md:p-4 rounded-xl border-2 text-left transition-all cursor-pointer ${
                active === cat.name
                  ? "border-primary-400 bg-primary-50 shadow-comic-sm"
                  : "border-background-200 bg-background-100 hover:border-primary-300"
              }`}
            >
              <span
                className={`w-10 h-10 md:w-11 md:h-11 shrink-0 rounded-lg flex items-center justify-center text-xl md:text-2xl ${
                  active === cat.name
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-200 text-secondary-800"
                }`}
              >
                <i className={cat.icon} aria-hidden="true"></i>
              </span>
              <span className="min-w-0">
                <span className="block font-heading text-foreground-950 text-sm md:text-base">
                  {cat.name}
                </span>
                <span className="block text-foreground-600 text-[11px] md:text-xs truncate">
                  {cat.desc}
                </span>
              </span>
            </button>
          ))}
        </div>

        {/* Filter tabs */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-6">
          {["全部", ...categories.map((c) => c.name)].map((name) => (
            <button
              key={name}
              type="button"
              onClick={() => setActive(name)}
              className={`px-4 py-1.5 rounded-full text-sm transition whitespace-nowrap cursor-pointer ${
                active === name
                  ? "bg-primary-500 text-background-50 font-bold"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100"
              }`}
            >
              {name}
            </button>
          ))}
        </div>

        {/* Comic grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {filtered.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}